import { render } from "./ScenariosTable.vue?vue&type=template&id=0c63425f"
import script from "./ScenariosTable.js?vue&type=script&lang=js"
export * from "./ScenariosTable.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__